import React from "react";

/** Parte etiquetas largas en 2 líneas (p. ej. "Avalancha" / "de escombros"). */
export function formatTipoTabLabelLines(label) {
  const text = String(label ?? "").trim();
  if (!text) return [];

  const parts = text.split(/\s+/).filter(Boolean);
  if (parts.length <= 1) return [text];
  if (parts.length === 2) return [parts[0], parts[1]];

  if (parts.length === 3 && (parts[1] === "de" || parts[1] === "y")) {
    return [parts[0], `${parts[1]} ${parts[2]}`];
  }

  /* "Corriente de densidad piroclástica" → 2 líneas; última palabra suelta encaja mejor en celdas estrechas */
  if (parts.length === 4 && parts[1] === "de") {
    return [`${parts[0]} ${parts[1]} ${parts[2]}`, parts[3]];
  }

  const mid = Math.ceil(parts.length / 2);
  return [parts.slice(0, mid).join(" "), parts.slice(mid).join(" ")];
}

export default function EvtTipoTabLabel({ label, forceSingleLine = false }) {
  const lines = forceSingleLine
    ? [String(label ?? "").trim()].filter(Boolean)
    : formatTipoTabLabelLines(label);

  if (lines.length <= 1) {
    return <span className="evt-efectos-tab__label">{lines[0] || label}</span>;
  }

  return (
    <span className="evt-efectos-tab__label evt-efectos-tab__label--multiline">
      {lines.map((line, index) => (
        <span key={`${line}-${index}`} className="evt-efectos-tab__label-line">
          {line}
        </span>
      ))}
    </span>
  );
}
